import React from "react";
import "../landing-page/css/media.css";
import "../landing-page/css/style.css";
import appleStore from "../landing-page/images/app-store-ic.svg";
import fLogoImage from "../landing-page/images/f-logo.svg";
import fbLogoImage from "../landing-page/images/fb-ic.svg";
import googlePlay from "../landing-page/images/google-pay-ic.svg";
import xLogoImage from "../landing-page/images/x-ic.svg";
import ytLogoImage from "../landing-page/images/yt-ic.svg";
import { useNavigate } from "react-router-dom";

const DownloadSection = () => {
  const navigate = useNavigate();
  return (
    <>
      <footer
        className="wow fadeInUp"
        style={{ visibility: "visible", animationName: "fadeInUp" }}
      >
        <div className="fixed-wrapper">
          <div className="footer-outer">
            <div className="f-logo md:!flex md:!flex-[0 0 100%] md:!justify-center sm:!flex sm:!flex-[0 0 100%] sm:!justify-center !flex !flex-[0 0 100%] !justify-center">
              <img src={fLogoImage} alt="Logo" />
            </div>
            <div className="f-buttons">
              <ul className="btn-list">
                <li>
                  <a href="#">
                    <img src={appleStore} alt="App Store" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={googlePlay} alt="Google Play" />
                  </a>
                </li>
              </ul>
            </div>

            <div className="f-social">
              <ul>
                <li>
                  <a href="#">
                    <img src={fbLogoImage} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={ytLogoImage} alt="YouTube" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={xLogoImage} alt="X (Twitter)" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="bg-[#061a3a] xl:p-4 lg:p-4  grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 ">
        <div className="!text-white flex xl:justify-start lg:justify-start md:justify-center justify-center gap-5 cursor-pointer !pt-4 lg:!pt-0 xl:!pt-0 sm:!pb-0 md:!pb-0">
          <div onClick={() => navigate("/privacy-policy")}>
            Privacy Policies
          </div>
          <div onClick={() => navigate("/terms-conditions")}>
            Terms & Conditions
          </div>
        </div>
        <div className="!text-white flex justify-center ">
          <p className="!text-sm xl:!text-base lg:!text-base md:!text-base ">
            Copyright &copy; <span>{new Date().getFullYear()}</span> TXTBet. All
            Rights Reserved.
          </p>
        </div>
        <div>&nbsp;</div>
      </div>
    </>
  );
};

export default DownloadSection;
